import * as React from 'react';

import LogoRow from '../../../containers/LogoRow/LogoRow';
import Graph from '../../../containers/Graph/Graph';
import { TopSectionLocale } from './topSection.locale';

import styles from './TopSection.scss';

import worldMap from './world-map.svg';
import { Query } from '../../../GraphQL';

interface TopSectionProps {
  locale: TopSectionLocale;
  traffic: Query['traffic'];
}

const TopSection: React.SFC<TopSectionProps> = ({ locale, traffic }) => (
  <div className={styles.topSection}>
    <div className="container">
      <LogoRow />
      <div className="row">
        <div className="col-12 col-md-9 col-lg-6">
          <h1 className={styles.mainTitle}>{locale.title}</h1>
        </div>
        <div className={styles.mapContainer}>
          <img src={worldMap} alt="" className={styles.map} />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-lg-7">
          <div className={styles.graphContainer}>
            <Graph title={locale.graphTitle} period={locale.graphPeriod} data={traffic} />
          </div>
        </div>
        <div className="col-12 col-lg-5">
          <p
            className={styles.graphDescription}
            dangerouslySetInnerHTML={{ __html: locale.graphDescription }}
          />
        </div>
      </div>
    </div>
  </div>
);

export default TopSection;



// WEBPACK FOOTER //
// /www/client/src/components/HomePage/TopSection/TopSection.tsx